import React, { FC, useEffect, useCallback, useMemo, useState } from "react"
import { THeatItem } from "@api/interfacePark"
import { heat } from "@api/park"
import Env from '@util/env'

/**
 * LayerHeat
 * @param param0
 */
const LayerHeat: FC<any> = ({ map, visible, district }) => {
  const [data, setData] = useState<THeatItem[]>([])
  const [heatMap, setHeatMap] = useState<any>()
  const getData = useCallback(async (key = "pd") => {
    let res = await heat(key)
    setData(res)
  }, [])

  useMemo(() => {
    if (!district) {
      setData(null)
      return
    }
    getData(district)
  }, [district])
  useMemo(() => {
    let heatData = []
    let max = 2
    if (!visible) {
      heatMap && heatMap.hide()
      return
    }
    if (data) {
      data.forEach((p) => {
        heatData.push({
          lng: p.lon,
          lat: p.lat,
          count: p.staff_count,
        })
        max = Math.max(max, p.staff_count)
      })
    }

    if (heatMap) {
      heatMap.show()
      heatMap.setDataSet({
        data: heatData,
        max: max,
      })
    }
  }, [data, heatMap, visible])
  useEffect(() => {
    map &&
      map.plugin(["AMap.Heatmap"], function () {
        //初始化heatmap对象
        var heatmap = new window.AMap.Heatmap(map, {
          radius: 40 * Env.getScale(), //给定半径
          opacity: [0, 0.7],
          // radius: 20, //给定半径
          // opacity: [0.1, 0.5],
          gradient: {
            0.25: "#0097FF",
            0.5: "#14CD33",
            0.75: "#FFF800",
            1: "#D01112",
          },

          zIndex: 1,
          zoom: [8, 20],
        })
        setHeatMap(heatmap)
      })
    // getData()
  }, [map, getData])
  return null
}

export default LayerHeat
